import React from 'react';
import { Table } from '../common';
import { Link } from 'react-router-dom';
import { CustomerT } from '../../types';
import dayjs from 'dayjs';
import { AddSquareIcon, DownloadIcon } from '../../assets/icons';
import {IPaginationMeta} from '../../@types';
import { CreateCustomer } from './Create';
import { useNavigate } from 'react-router-dom';
import DropdownButton from '../common/Table/MobileTableComponent/DropdownOptions';


interface customersTableProps {
  customers: CustomerT[];
  isLoading: boolean;
  fetchMoreData: (page: string, cursor?: string, _backCursor?: string) => void;
  meta: IPaginationMeta;
  onSearchData: (text: any) => void;
  isSearching: boolean | undefined;
  showHead?: true | undefined;
  handleSort?: (text: string) => void;
  handleSearch?: (text: string) => void;
  searchResult: CustomerT[];
}

const CustomersTable = ({
  customers,
  isLoading,
  fetchMoreData,
  meta,
  searchResult,
  handleSearch,
  handleSort,
}: customersTableProps) => {
  const navigate = useNavigate();
  const [DrawerOpen, setDrawerOpen] = React.useState<boolean>(false);
  const [dropdown, setDropdown] = React.useState(false);
  const[createExpense, setCreateExpense] = React.useState(false)
  const toggleDrawer = () => { 
    setDrawerOpen((prevState) => !prevState);
  };

  const renderCustomersData = (customers: CustomerT[]) => {
    return customers.map((cus) => ({
      customer: (
        <Link className="xl:text-violet-800" to={`/customers/${cus.id}/view`}>
          {cus.firstName} {cus.lastName}
        </Link>
      ),
      id: cus.id,
      email: cus.email,
      billed: `₦${cus.totalBilled ? cus.totalBilled : '0'}`, 
      invoiceNumber: cus.totalInvoices || '0',
      createdAt: dayjs(cus.createdAt).format('DD/MM/YYYY'),
    }));
  };

  const renderCustomersTableHead = () => {
    return {
      customer: { title: 'CUSTOMER' },
      email: { title: 'EMAIL ADDRESS' },
      billed: { title: 'TOTAL BILLED' },
      invoiceNumber: { title: '# OF INVOICES' },
      createdAt: { title: 'LAST ACTIVE' },
    };
  };
  const onSearch = (text: string) => {
    if (handleSearch) {
      handleSearch(text);
    }
  };
  const handleSearchSelect = (item: any) => {
    console.log("item", item)
    navigate(`/customers/${item.id}/view`);
  };
  return (
    <>
    <div className='hidden md:block whitespace-nowrap'>
      <Table
        searchPlaceHolder="Search "
        searchDisplayKey={"name"}
        searchResult={searchResult}
        handleSearchSelect={handleSearchSelect}
        head={renderCustomersTableHead()}
        data={renderCustomersData(customers)}
        isLoading={isLoading}
        showHead
        buttons={[
          {
            text: 'New Customer',
            onClick: toggleDrawer,
            icon: <AddSquareIcon />,
          },
          {
            text: 'Import',
            icon: <DownloadIcon />,
          },
        ]}
        showPagination
        handleSearch={onSearch}
        handleSort={handleSort}
        fetchMoreData={fetchMoreData}
        meta={meta}
      />
      <CreateCustomer show={DrawerOpen} />
    </div>

    <div className='block md:hidden mt-[12px] '>
    <div className='relative'>  
      <button
        className="bg-[#044E97] text-[#FFFFFF] absolute text-[16px] mt-[-450px] ml-[18em] flex w-11 h-11 rounded-full justify-center items-center py-[12.5px] leading-4 first-letter font-semibold"
        onClick={() => setDropdown((prev) => !prev)}
      >
        {dropdown ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6 inline-block items-center "
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6 inline-block"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
        )}
      </button>
         {dropdown && (
        <div className="shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] w-[240px] bg-[#ffff] pt-[15px] shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] absolute bottom-[50px] ml-[11em] mt-[11em] ">
          <h3 className="">
            <Link to={'/customer/create'} className="text-[#000] px-[16px] hover:text-blue-500">
              New Customer
            </Link>
          </h3>
          <h3 className="text-[#000] py-[12px] px-[16px] ">
            <Link to={''} className="hover:text-blue-500">
              Import
            </Link>
          </h3>
        </div>
      )}
      
    </div>
     <div className='flex md:hidden justify-center items-center xl:pl-[50px] 2xl:pl-[50px] 3xl:pl-[50px] 4xl:pl-[50px] biglg:pl-[30px] lg:pl-[5px] md:pl-[1px] bigmd:pl-[5px]'>
        <Table
        searchPlaceHolder="Search "
        searchDisplayKey={"name"}
        searchResult={searchResult}
        handleSearchSelect={handleSearchSelect}
        head={renderCustomersTableHead()}
        data={renderCustomersData(customers)}
        isLoading={isLoading}
        showHead
     
       
        buttons={[
          {
            text: 'New Customer',
            onClick: toggleDrawer,
            icon: <AddSquareIcon />,
          },
        ]}
        showPagination
        handleSearch={onSearch}
        handleSort={handleSort}
        fetchMoreData={fetchMoreData}
        meta={meta} 
        CustomerCard={true}
   />
  
   <CreateCustomer show={DrawerOpen} />
</div>


</div>
    
      
    </>
  );
};

export default CustomersTable;
